import React from 'react';
import {Box, Link, Stack, Typography} from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {router} from 'app/router/main';

interface Props {
  paymentAccess: boolean;
}

export default function UnpaidFeature({paymentAccess}: Props) {
  return (
    <Box width={320}>
      <Stack direction="row" gap={1} alignItems="center" mb={1}>
        <LockOpenIcon color="error" />
        <Typography fontWeight={600}>Feature disabled</Typography>
      </Stack>

      <Typography>
        This feature is currently unavailable due to a payment issue.{' '}
        {paymentAccess ? (
          <>
            <Link href={`${router.url('settingBillingUsage')}`}>Update your payment method</Link> to
            restore access.
          </>
        ) : (
          <>Contact the team owner to restore access.</>
        )}
      </Typography>
    </Box>
  );
}
